import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnippetComponent } from './snippet/snippet.component';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule } from '@angular/forms';
import { SnippetManagerComponent } from './snippet-manager/snippet-manager.component';

@NgModule({
  declarations: [SnippetComponent, SnippetManagerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule
  ]
})
export class SnippetModule {
  customElementComponent: Type<any> = SnippetComponent;
}
